<!-- The about page is formatted using vue-simple-accordion -->
<!-- Ref link for vue-simple-accordion: https://developer.aliyun.com/mirror/npm/package/vue-simple-accordion/v/0.0.1?spm=a2c6h.14275010.0.0.5b183b77r1qw2f&file=0.0.1 -->
<template>
  <div>
    <h1>ABOUT LANTERN</h1>
    <vsa-list>
      <vsa-item>
        <vsa-heading>What is LANTERN?</vsa-heading>
        <vsa-content>
          <div class="indented">
            LANTERN (natura
            <b>
              <u>L</u>
            </b> l
            <b>
              <u>AN</u>
            </b>guage descrip
            <b>
              <u>T</u>
            </b>ion of qu
            <b>
              <u>ER</u>
            </b>y pla
            <b>
              <u>N</u>
            </b>s) is a novel system
            that facilitates natural language interaction with
            <i>query execution plan</i> (QEP), which supports boredom-conscious natural language(NL) description generation of QEP of an
            arbitrary sql query posed on an RDBMS. Given an sql query, instead of purely visual or semi-structured format of QEP,
            LANTERN generates multi-faceted NL-based description of the steps in the QEP. Under the hood, LANTERN provides a declarative framework called POOL(
            <b>
              <u>P</u>
            </b>hysical
            <b>
              <u>O</u>
            </b>perator
            <b>
              <u>O</u>
            </b>bject
            <b>
              <u>L</u>
            </b>anguage) to enable
            subject matter experts (SMEs) to create and manipulate NL descriptions (i.e., labels) of physical operators, which are building blocks of QEPs. It implements
            a NL description generation framework that utilizes POOL to integrate rule-based and deep learning-based techniques in order to infuse language variability
            in the descriptions opportunely. This strategy mitigates the impact of boredom on learners that may arise due to repetitive statements in different NL descriptions
            generated by purely rule-based techniques.
          </div>
        </vsa-content>
      </vsa-item>
      <vsa-item>
        <vsa-heading>Where can I find more information regarding LANTERN?</vsa-heading>
        <vsa-content>
          <div class="indented">
            <strong>Publications:</strong>
            <ul>
              <li>
                Liu et al. NEURON: Query Execution Plan Meets Natural Language Processing For Augmenting DB Education.
                <i>In ACM SIGMOD, 2019</i>. [
                <a href="https://dl.acm.org/doi/10.1145/3299869.3320213" active target="_blank">PDF</a>]
                [
                <a href="https://www.youtube.com/watch?v=wRIWuYbU2F0" active target="_blank">video</a>]
              </li>
              <li>
                Wang et al. Towards Enhancing Database Education: Natural Language Generation Meets Query Execution Plans.
                <i>In ACM SIGMOD, 2021</i>.[
                <a href="https://dl.acm.org/doi/10.1145/3448016.3452822" active target="_blank">PDF</a>]
              </li>
              <li>
                Chen et al. LANTERN: Boredom-conscious Natural Language Description Generation of Query Execution Plans for Database Education.
                <i>In ACM SIGMOD, 2022</i>.
                [
                <a href="https://youtu.be/0pNOOnR-Ezk" active target="_blank">video</a>]
              </li>
            </ul>
          </div>
        </vsa-content>
      </vsa-item>
      <vsa-item>
        <vsa-heading>Contact Us</vsa-heading>
        <vsa-content>
          <div class="indented">
            For feedback and comments, please email to
            <a href="mailto:hli@xidian.edu.cn">hli@xidian.edu.cn</a>.
          </div>
        </vsa-content>
      </vsa-item>
    </vsa-list>
    <!-- router -->
    <router-view></router-view>
  </div>
</template>
<script>
import { VsaList, VsaItem, VsaHeading, VsaContent } from 'vue-simple-accordion'
//import '@/assets/css/vue-simple-accordion.css';
import 'vue-simple-accordion/dist/vue-simple-accordion.css'
export default {
  name: 'About',
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent
  }
}
</script>